import { render, staticRenderFns } from "./adminToolGlassSetup.vue?vue&type=template&id=8ce60320&"
import script from "./adminToolGlassSetup.vue?vue&type=script&lang=js&"
export * from "./adminToolGlassSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports